<template>
  <div>
    <dt class="text-danger">{{ label }}</dt>
    <dd class="text-danger" v-html="'Componente não configurado'" />
  </div>
</template>

<script>
export default {
  name: "view-c-default",
  props: {
    label: String
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/View/Default.vue